exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CodeSample code{font-size:13px;line-height:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CodeSample.css
// module id = ./src/components/CodeSample.css
// module chunks = 2345137460201621000 13254968351354405000 17463659626562118000